module.exports = __webpack_public_path__ + "static/media/coppia.c778d023.jpg";